enum StatusLabelStatus {
  ACTION = 'action',
  INCOMPLETE = 'incomplete',
  IN_PROGRESS = 'in-progress',
  PARTNER = 'partner',
  SUCCESS = 'success',
  WARNING = 'warning',
}

enum StatusLabelClassNames {
  ACTION = 'FountainStatusLabel-action',
  INCOMPLETE = 'FountainStatusLabel-incomplete',
  IN_PROGRESS = 'FountainStatusLabel-in-progress',
  PARTNER = 'FountainStatusLabel-partner',
  SUCCESS = 'FountainStatusLabel-success',
  WARNING = 'FountainStatusLabel-warning',

  LABEL = 'FountainStatusLabel-label',
  HOVER_STATE = 'FountainStatusLabel-hover-state',
  ACTION_ICON = 'FountainStatusLabel-action-icon',
  DOT = 'FountainStatusLabel-dot',
  PRIMARY_LABEL_TEXT = 'FountainStatusLabel-primary-label-text',
  PRIORITY_LABEL_TEXT = 'FountainStatusLabel-priority-label-text',
  ROOT = 'FountainStatusLabel-root',
  STATUS_ICON = 'FountainStatusLabel-status-icon',
  MENU_ACTIONS = 'FountainStatusLabel-menu-actions',
  MENU_CONTAINER = 'FountainStatusLabel-menu-container',
  MENU_PAPER = 'FountainStatusLabel-menu-paper',
}

enum IconTypes {
  CARET = 'Caret',
  CHECKBOX_CHECKED = 'Checkbox Checked',
  CHECKBOX_EMPTY = 'Checkbox Empty',
  CHECKBOX_INDETERMINATE = 'Checkbox Indeterminant',
  INCOMPLETE = 'Incomplete',
  IN_PROGRESS = 'InProgress',
  MOVE_TO_NEXT_STAGE = 'MoveToNextStage',
  REJECT = 'Reject',
  SUCCESS = 'Success',
  WARNING = 'Warning',
}

export { IconTypes, StatusLabelClassNames, StatusLabelStatus };
